@import '../../../globals/main.scss';

pn-product-tile-info {
  align-self: center;
}
